import {AutoplayOptions, AutoplayOptionsOptionsKeys, ReactPIXISystemPopup} from '@gongxigames/framework/slot/types';
import {DataStorage} from '@gongxigames/framework/core';

export type AutoplayStoredValues = AutoplayOptions & {
    notValidValues?: AutoplayOptionsOptionsKeys[];
};

export type AutoplayOptionsDataStorage = DataStorage<AutoplayStoredValues>;

export type AutoplayShowOptionsPopupProperties = {
    autoplayValues: number[];
    disabledTurboButton: boolean;
    disabledLimits?: boolean;
    autoplayShowBetAndWager?: boolean;
    autoplayShowConfirmationPopup?: boolean;
    requiredOptions?: AutoplayOptionsOptionsKeys[];
    defaultOptions?: Partial<AutoplayStoredValues>;
};

export type AutoplayOptionsPopupData = {
    options: AutoplayOptionsDataStorage;
    roundsOptions: number[];
    turboModeDisabled: boolean;
    disabledLimits?: boolean;
    autoplayShowBetAndWager?: boolean;
    autoplayShowConfirmationPopup?: boolean;
    totalBet?: number;
    setOption: <K extends keyof AutoplayOptions>(key: K, value: AutoplayOptions[K]) => void;
    startAutoplay: () => void;
    closeAutoplayOptionsPopup: () => void;
};

export type AutoplayOptionsPopup = ReactPIXISystemPopup<AutoplayOptionsPopupData>;
